import { openidRegisterLogin } from '@/api/login'
import router from '../../router'
export const isLogin = (openid, name, params) => {
  openidRegisterLogin(openid).then(res => {
    if (res.data.code === 200) {
      sessionStorage.setItem('memberId', res.data.data.memberId)
      sessionStorage.setItem('token', res.data.data.token)
      sessionStorage.setItem('currentName', name)
      sessionStorage.setItem('jurisdictionId', res.data.data.version)
      sessionStorage.setItem('isSale', res.data.data.isSale)
      if (name === 'managementBind' && res.data.data.newUser !== 0) {
        router.replace({
          name: 'getFreeSkills',
          query: {
            name: name
          }
        })
        return
      }
      if (name === 'index' && res.data.data.version === 2) {
        name = 'currentIndex'
      }
      if (name === 'learningAssistant' && res.data.data.version === 2) {
        name = 'learningAssistantNew'
      }
      router.replace({
        name: name,
        params: params
      })
      return
    }
  })
}
